import { render, staticRenderFns } from "./GroupMemberManagerModal.vue?vue&type=template&id=5e3b1fc0&"
import script from "./GroupMemberManagerModal.vue?vue&type=script&lang=js&"
export * from "./GroupMemberManagerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports